export const QueryUtil = {
  withRequired: (requiredOption: boolean, optionEnabled: boolean | undefined) =>
    requiredOption && (optionEnabled !== undefined ? optionEnabled : true),
};
